import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import cx from 'classnames';
import Paper from '@mui/material/Paper';
import { EditableInput } from 'react-color/lib/components/common';
import LoaderSmall from 'app/components/LoaderSmall/LoaderSmall.jsx';
import classes from 'app/components/Form/ColorPicker/ColorPicker.module.scss';
import htmlColors from 'app/styles/htmlColors';
export function ColorPicker(props) {
    const { colors = htmlColors, value, onChange: _onChange } = props;
    const [isLoading, setIsLoading] = useState(false);
    function onChange(color) {
        var _a;
        setIsLoading(true);
        return (_a = _onChange(color)) === null || _a === void 0 ? void 0 : _a.finally(() => {
            setIsLoading(false);
        });
    }
    function colorRound(color, title, showSelected = true) {
        if (!color)
            return null;
        return (_jsx("div", { style: { backgroundColor: color }, className: cx(classes.colorRound, { [classes.selected]: showSelected && color === value }), title: title, onClick: () => onChange(color) }, `${color}-${title || ''}`));
    }
    function mapColors(items) {
        return items.map((item) => {
            if (typeof item === 'string')
                return colorRound(item);
            if (Array.isArray(item))
                return mapColors(item);
            if (typeof item === 'object')
                return colorRound(item.color, item.title);
            return null;
        });
    }
    return (_jsxs(Paper, { style: { padding: '8px 0px 8px 8px', width: 205 }, children: [_jsx("div", { className: classes.scrollingContainer, children: _jsx("div", { className: "fullWidth fullHeight flex row wrap", children: mapColors(colors) }) }), _jsxs("div", { className: "fullWidth flex alignCenter", style: { margin: '10px 0px 0px 0px' }, children: [_jsx(EditableInput, { style: {
                            input: {
                                border: '1px solid rgba(0,0,0,0.1)',
                                fontSize: '14px',
                                padding: '3px 6px',
                                outline: 'none',
                                marginRight: 5,
                            },
                        }, value: value, onChange: (color) => {
                            onChange(color);
                        } }), isLoading ? _jsx(LoaderSmall, { color: "grey" }) : colorRound(value, undefined, false)] })] }));
}
